import React from 'react';
import ThemeToggle from '../ThemeToggle';

const NAV_ITEMS = [
	{ href: '#home', label: 'Home' },
	{ href: '#about', label: 'Stats' },
	{ href: '#projects', label: 'Quest Log' },
	{ href: '#contact', label: 'Guild Hall' },
];

const NavbarV2 = ({ theme, onToggleTheme }) => (
	<nav className="fixed w-full z-50 bg-ink/85 backdrop-blur border-b border-gold/30 shadow-[0_1px_20px_rgba(201,164,74,0.15)]">
		<div className="max-w-7xl mx-auto px-4 flex justify-between items-center h-16">
			<div className="flex items-center gap-3">
				<span className="font-display text-lg text-gold tracking-wide">Sam Togun</span>
				<span className="hidden sm:inline-flex items-center font-mono text-[10px] px-2 py-0.5 rounded border border-rpgblue/50 text-rpgblue">
					Lvl 99
				</span>
				<span className="hidden sm:inline-flex items-center font-mono text-[10px] px-2 py-0.5 rounded border border-blorange/60 text-blorange">
					✦ Mythic
				</span>
			</div>
			<div className="flex items-center gap-6">
				{NAV_ITEMS.map(item => (
					<a
						key={item.href}
						href={item.href}
						className="hidden md:inline font-mono text-xs uppercase tracking-wider text-gray-300 hover:text-gold transition-colors"
					>
						{item.label}
					</a>
				))}
				<ThemeToggle theme={theme} onToggle={onToggleTheme} />
			</div>
		</div>
	</nav>
);

export default NavbarV2;
